import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ts_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "حدث خطأ، حاول مرة أخرى.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}

export const SAR = "ر.س";

// Official platform (customer-support) WhatsApp number — NOT a salvage-yard number.
export const SUPPORT_WHATSAPP = "0569149795";
export const SUPPORT_MESSAGE = "مرحبًا، أحتاج مساعدة من دعم منصة التشاليح.";
export const supportWaLink = () => waLink(SUPPORT_WHATSAPP, SUPPORT_MESSAGE);

export function waLink(phone, text) {
  let p = (phone || "").replace(/\D/g, "");
  if (p.startsWith("00")) p = p.slice(2);
  if (p.startsWith("0")) p = "966" + p.slice(1);
  else if (!p.startsWith("966")) p = "966" + p;
  return `https://wa.me/${p}?text=${encodeURIComponent(text || "")}`;
}

export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("no-geo"));
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      reject,
      { timeout: 9000, enableHighAccuracy: true }
    );
  });
}
